module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/assessment_achievements/2_8cc8974acc74cc917df9ff7683b3dd4a.png";